import { useQuery } from 'urql';

import { HeatPumpIndoorUnitsDocument, HeatPumpOutdoorUnitsDocument } from '~src/graphql';
import { HeatPumpIndoorUnit, HeatPumpOutdoorUnit } from '~src/model';

import { FetchProductParameters } from './model';

export const useFetchHeatPumpOutdoorUnits = ({ pause }: FetchProductParameters = {}) => {
  const [result] = useQuery({
    query: HeatPumpOutdoorUnitsDocument,
    requestPolicy: 'network-only',
    pause,
  });

  return { ...result, data: result.data?.heatPumpOutdoorUnits as HeatPumpOutdoorUnit[] };
};

export const useFetchHeatPumpIndoorUnits = ({ pause }: FetchProductParameters = {}) => {
  const [result] = useQuery({
    query: HeatPumpIndoorUnitsDocument,
    requestPolicy: 'network-only',
    pause,
  });

  return { ...result, data: result?.data?.heatPumpIndoorUnits as HeatPumpIndoorUnit[] };
};
